"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialJourneyState = getInitialJourneyState;
function getInitialJourneyState(params) {
    if (params === null || params === void 0 ? void 0 : params.customIntroEnabled) {
        return 'INTRO';
    }
    else if (params === null || params === void 0 ? void 0 : params.configSpec) {
        return 'CONFIG';
    }
    else if (params === null || params === void 0 ? void 0 : params.tutorialAvailable) {
        return 'TUTORIAL';
    }
    else if (params === null || params === void 0 ? void 0 : params.enableTestTask) {
        return 'TEST_TASK';
    }
    return 'MAIN_TASK';
}
//# sourceMappingURL=JourneyState.js.map